import { effects } from 'redux-saga';
import { AppReduxTypes } from '../app/appRedux';
import Actions, { LanguageSwitcherReduxTypes } from './languageSwitcherRedux';
import AppLocale from '../../languageProvider';
import * as R from 'ramda';
import { getCurrentPath, sleep } from '../../helpers/utility';
import AppConfig from '../../config/AppConfig';
import { push } from 'react-router-redux';

export const currentLanguageFnc = (state) => state.Language.language;
export const currentLanguageRfc3066Fnc = (state) => state.Language.language.rfc3066;

export function* changeLanguage(action) {
    const path = getCurrentPath();
    console.log('[CHANGE_LANGUAGE] current path is :', path, ' action is :', action);
    const pathArray: string[] = path.split('/');
    const langInPath = pathArray[1];
    if (langInPath !== action.language) {
        pathArray[1] = action.language;
        const newLocation = `/${pathArray.join('/')}`;
        console.log('[CHANGE_LANGUAGE] Redirecting to :', newLocation);
        yield effects.put(push(newLocation));
    }
}

export function* startup() {
    const tag = '[STARTUP][LANGUAGE_SWITCHER]';
    console.log(`${tag} Installed languages are : `, R.keys(AppLocale));
    try {
        const path = getCurrentPath();
        const pathArray: string[] = path.split('/');
        let currentLang = pathArray[1];
        if (R.contains(currentLang, R.keys(AppLocale))) {
            console.log(`${tag} current language is : `, currentLang, ' based on url : ', path);
        } else {
            console.warn(`${tag} Failed to determine current language ! setting it to default :`, AppConfig.defaultLanguage);
            currentLang = AppConfig.defaultLanguage;
        }
        yield effects.put(Actions.changeLanguage(currentLang));


    } catch (e) {
        console.warn(`${tag} Failed to startup : ${e.message}`);
    }


}

export default function* rootSaga() {
    yield effects.all([
        effects.takeLatest(AppReduxTypes.STARTUP, startup),
        effects.takeLatest(LanguageSwitcherReduxTypes.CHANGE_LANGUAGE, changeLanguage)
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/languageSwitcher/languageSwitcherSaga.ts